<template>
    <kt-row v-if="status === 'setFormData'">
        <kt-col xs="12">
            <form @submit.prevent="edit" id="wage_settings">
                <kt-form-group>
                    <div class="container p-3 pt-5 my-4 border in-border-header">
                        <kt-form-section is_first>
                            <div class="section-header">
                                {{ $t('label.pardakht_shakhsi_setting') }}
                            </div>

                            <kt-form-group
                            >
                                <kt-form-label>
                                    {{ $t('label.change_wage_type') }}
                                </kt-form-label>
                                <kt-form-select size="3" id="wage_type" v-model="pardakht_shakhsi.wage_plan"
                                                name="wage_type">
                                    <option
                                            v-bind:key="index"
                                            v-for="(wage_type, index) in wage_types"
                                            v-bind:value="wage_type.value"
                                            :selected="wage_type.value"
                                    >
                                        {{ wage_type.name }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>

                            <transition name="fade"
                                        v-if="pardakht_shakhsi.wage_plan === 'PERIODIC' "
                            >
                                <kt-form-group>
                                    <kt-form-label>
                                        {{ $t('label.change_wage_period') }}
                                    </kt-form-label>
                                    <kt-form-select
                                            size="4"
                                            id="wage_periodic_type"
                                            name="wage_periodic_type"
                                            v-model="pardakht_shakhsi.wage_periodic_type"
                                    >
                                        <option
                                                v-bind:key="index"
                                                v-for="(wage_periodic_type, index) in wage_periodic_types"
                                                v-bind:value="wage_periodic_type.value"
                                                :selected="wage_periodic_type.value"
                                        >
                                            {{ wage_periodic_type.name }}
                                        </option>
                                    </kt-form-select>
                                </kt-form-group>
                            </transition>
                            <transition name="fade"
                            >
                                <kt-form-group>
                                    <kt-form-label>
                                        {{
                                            $t('label.wage_amount_percent')
                                        }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--left">
                                        <kt-form-control dir="ltr" id="wage_amount" name="wage_amount"
                                                         v-model="pardakht_shakhsi.wage_amount">
                                            {{
                                                (pardakht_shakhsi.wage_plan === 'PERCENT') ?
                                                        $t('label.wage_amount_percent') :
                                                        ((pardakht_shakhsi.wage_plan === 'FIXED') ?
                                                                $t('label.wage_amount_fixed') :
                                                                $t('label.wage_amount_periodic'))
                                            }}
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                                 <span>{{
                                                         (pardakht_shakhsi.wage_plan === 'PERCENT') ?
                                                                 $t('label.percent') :
                                                                 $t('currency.rial')
                                                     }}</span>
                                            </span>
                                    </div>
                                </kt-form-group>
                            </transition>
                            <transition name="fade"
                            >
                                <kt-form-group v-if="pardakht_shakhsi.wage_plan === 'PERCENT'">
                                    <kt-form-label>
                                        {{ $t('label.min_wage_amount') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--left">
                                        <kt-form-control dir="ltr"
                                                         id="wage_min_wage"
                                                         name="wage_min_wage"
                                                         v-model="pardakht_shakhsi.wage_min_wage"
                                        >
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                        <span>{{ $t('currency.rial') }}</span>
                                   </span>
                                    </div>
                                </kt-form-group>
                            </transition>
                            <transition name="fade"
                            >
                                <kt-form-group v-if="pardakht_shakhsi.wage_plan === 'PERCENT'">
                                    <kt-form-label>
                                        {{ $t('label.max_wage_amount') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--left">
                                        <kt-form-control dir="ltr" id="wage_max_wage" name="wage_max_wage"
                                                         v-model="pardakht_shakhsi.wage_max_wage"
                                        >
                                        </kt-form-control>
                                        <span class="kt-input-icon__icon kt-input-icon__icon--left">
                                                    <span>{{ $t('currency.rial') }}</span>
                                            </span>
                                    </div>
                                </kt-form-group>
                            </transition>
                        </kt-form-section>
                        <kt-row lg="12" md="12" xs="12" class="ml-1 mt-3 mb-3">
                            <div style="margin-top: 25px" class="custom-control custom-checkbox"
                                 id="pardakht_shakhsi_status-div">
                                <input
                                        type="checkbox"
                                        class="custom-control-input"
                                        id="pardakht_shakhsi_status"
                                        name="pardakht_shakhsi_status"
                                        v-model="pardakht_shakhsi.pardakht_shakhsi_status"
                                >
                                <label class="custom-control-label" id="pardakht_shakhsi_status_label"
                                       for="pardakht_shakhsi_status">
                                    {{ $t('label.pardakht_shakhsi_status') }}
                                </label>

                            </div>
                        </kt-row>
                        <kt-form-action class="mt-4">
                            <button class="btn btn-md btn-success btn-wide" type="submit" id="change_wage_btn">
                                {{ $t('btn.edit') }}
                            </button>
                        </kt-form-action>
                    </div>

                </kt-form-group>
            </form>
            <form id="settings_form" style="margin-top: 30px" @submit.prevent="editSettings">
                <div class="container p-3 pt-5 my-4 border in-border-header">
                    <kt-form-section is_first>
                        <div class="section-header">
                            {{ $t('pardakht_shakhsi.dedicated_settings') }}
                        </div>
                        <kt-row class="col-12">
                            <default-psp-setting :settings="pardakht_shakhsi"></default-psp-setting>
                        </kt-row>
                        <kt-row>
                            <kt-col lg="12" md="12" sm="12" style="margin-top: 15px">
                                <div class="custom-control custom-switch">
                                    <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            id="need_authentication"
                                            name="need_authentication"
                                            v-model="pardakht_shakhsi.need_authentication"
                                    >
                                    <label class="custom-control-label" for="need_authentication">
                                        {{ $t('label.ipg_link_authentication_status') }}
                                    </label>
                                </div>
                            </kt-col>
                        </kt-row>
                        <kt-form-action class="mt-4">
                            <button class="btn btn-md btn-success btn-wide" type="submit" id="change_settings_btn">
                                {{ $t('btn.edit') }}
                            </button>
                        </kt-form-action>
                    </kt-form-section>
                </div>
            </form>
        </kt-col>
    </kt-row>
</template>

<script>
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {mapGetters} from 'vuex'
import {pardakhtShakhsiService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n'
import defaultPspSetting from './default-psp-setting'

export default {
    components: {
        'default-psp-setting': defaultPspSetting
    },
    data() {
        return {
            wage_types: [
                {
                    name: this.$t('gateway.wage_types.percent'),
                    value: 'PERCENT'
                },
                {
                    name: this.$t('gateway.wage_types.fixed'),
                    value: 'FIXED'
                },
                {
                    name: this.$t('gateway.wage_types.periodic'),
                    value: 'PERIODIC',
                }
            ],
            wage_periodic_types: [
                {
                    name: this.$t('gateway.wage_periodic_types.1'),
                    value: 1
                },
                {
                    name: this.$t('gateway.wage_periodic_types.3'),
                    value: 3
                },
                {
                    name: this.$t('gateway.wage_periodic_types.6'),
                    value: 6,
                },
                {
                    name: this.$t('gateway.wage_periodic_types.12'),
                    value: 12,
                }
            ],
        }
    },
    computed: {
        ...mapGetters('pardakhtShakhsi', {
            pardakht_shakhsi: 'form_data',
            status: 'status'
        }),
    },
    methods: {
        edit(e) {
            let btn = $('#change_wage_btn')
            let form = $('#wage_settings')

            let params = {
                pardakht_shakhsi_status: this.pardakht_shakhsi.pardakht_shakhsi_status,
                wage_plan: this.pardakht_shakhsi.wage_plan,
                wage_amount: this.pardakht_shakhsi.wage_amount
            }
            if (this.pardakht_shakhsi.wage_plan === 'PERIODIC') {
                params.wage_periodic_type = this.pardakht_shakhsi.wage_periodic_type;
            }
            if (this.pardakht_shakhsi.wage_plan === 'PERCENT') {
                params.wage_min_wage = this.pardakht_shakhsi.wage_min_wage;
                params.wage_max_wage = this.pardakht_shakhsi.wage_max_wage;
            }
            KTApp.progress(btn)
            pardakhtShakhsiService.changeWage(this.pardakht_shakhsi.id, params).then(response => {
                this.showMsg($('#setting_col'), 'success', response.data.message)
            }).catch(({response}) => {
                form.validate().showErrors(response.data.data)
            })

            setTimeout(() => {
                KTApp.unprogress(btn)
            }, 1000)
        },
        editSettings(e) {
            let btn = $('#change_settings_btn')
            let form = $('#settings_form')
            let params = {
                hashid: this.pardakht_shakhsi.id,
                default_psp: this.pardakht_shakhsi.default_psp,
                default_corporate: this.pardakht_shakhsi.default_corporate,
                need_authentication: this.pardakht_shakhsi.need_authentication,
            }
            KTApp.progress(btn)
            pardakhtShakhsiService.changeDedicatedSettings(params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
        wageNumber() {
            this.pardakht_shakhsi.wage = this.pardakht_shakhsi.wage.replace(/[,]/g, '')
        },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    mounted() {
        setTimeout(() => {
            this.wageNumber()
            this.afterDispatch();
        }, 4000)
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>